import handleClick from "../../utils/handleClick.js";
import useVisible from "../../hooks/useVisible.jsx";

function RenderComps({
  isVisible,
  setIsVisible,
  useCepStorage,
  saveCepStorage,
  getCepStorage,
  optionsPath,
  selectedTag,
  buttonTags,
  generateButtonTags,
  button,
}) {
  const H264 = "H.264";
  const QUICK_TIME = "QuickTime";
  const FORMAT = `${optionsPath}.format`;
  const REPLACE_COMPOSITION = `${optionsPath}.replaceComposition`;

  const [format, setFormat] = useCepStorage(FORMAT);
  const [replaceComposition, setReplaceComposition] =
    useCepStorage(REPLACE_COMPOSITION);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-regular fa-film"></i>
        </div>
        <div className="button-card__title">Render Comps</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__checkbox-group">
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="render-comp-replace-composition"
              checked={replaceComposition}
              onChange={() => setReplaceComposition(!replaceComposition)}
              className="hidden-checkbox"
            />
            <label htmlFor="render-comp-replace-composition">
              <span className="custom-checkbox"></span>
              <span className="label-text">Replace Composition</span>
            </label>
          </div>
          <div className="render-group__dropdown">
            <span className="render-group__dropdown-text">Format</span>
            <select
              id="type"
              name="type"
              onChange={(event) => setFormat(event.target.value)}
              value={format}
            >
              <option value={H264}>MP4</option>
              <option value={QUICK_TIME}>MOV Alpha</option>
            </select>
          </div>
        </div>

        <div className="render-group__tools-grid">
          <div
            onClick={() => {
              handleClick("renderComps", {
                type: "layer",
                format: format,
                replaceComposition: replaceComposition,
              });
            }}
            className="render-group__button"
          >
            <i class="fa-light fa-layer-group"></i>
            <span className="render-group__button-text">Selected Layers</span>
          </div>
          <div
            onClick={() => {
              handleClick("renderComps", {
                type: "comp",
                format: format,
                replaceComposition: replaceComposition,
              });
            }}
            className="render-group__button"
          >
            <i class="fa-solid fa-image-polaroid"></i>
            <span className="render-group__button-text">Active Comp</span>
          </div>
          <div
            onClick={() => {
              handleClick("renderComps", {
                type: "selected comp",
                format: format,
                replaceComposition: replaceComposition,
              });
            }}
            className="render-group__button"
          >
            <i class="fa-solid fa-images"></i>
            <span className="render-group__button-text">Selected Comp</span>
          </div>

          {/* <div
            onClick={() => {
              handleClick("ae2ppImportFootage", { type: checkedOption });
            }}
            className="render-group__button"
          >
            <i class="fa-light fa-video-arrow-down-left"></i>
            <span className="render-group__button-text">Import Footage</span>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default RenderComps;
